module.exports = __webpack_public_path__ + "static/media/signage-indoor-img18.674342cb.jpg";